import { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from 'react';
import type { Map as MapGL } from '@2gis/mapgl/types';

const MapglContext = createContext<{
    mapgl?: any;
    mapglInstance?: MapGL;
    setMapglContext: Dispatch<SetStateAction<MapContextState>>;
}>({
    mapgl: undefined,
    mapglInstance: undefined,
    setMapglContext: () => {},
});

interface MapContextState {
    mapglInstance?: MapGL;
    mapgl?: any;
}

export function useMapglContext() {
    return useContext(MapglContext);
}

export function MapglContextProvider({ children }: { children: ReactNode }) {
    const [{ mapglInstance, mapgl }, setMapglContext] = useState<MapContextState>({
        mapglInstance: undefined,
        mapgl: undefined,
    });
    return (
        <MapglContext.Provider value={{ mapgl, mapglInstance, setMapglContext }}>
            {children}
        </MapglContext.Provider>
    );
}
